import { Router } from '@angular/router';

import { ActionReducer, MetaReducer, UPDATE } from '@ngrx/store';

import { LanguageService } from '@fcom/ui-translate';
import { CartPartStatus, CartState, UpdatingCartPart } from '@fcom/dapi';
import { isNotEmpty, safeMap } from '@fcom/core/utils';
import { SentryLogger } from '@fcom/core/services';

import { navigateToError } from '../../utils/route-utils';

/**
 * During reducer UPDATE check that the current CartState is a coherent one. If not navigate to sorry page.
 * @param router Router to use for navigating
 * @param languageService LanguageService to use
 * @param sentryLogger Logger to use
 * @returns {(reducer: ActionReducer<CartState>) => ActionReducer<CartState>}
 */
export function verifyCartInitialStateMetaReducer(
  router: Router,
  languageService: LanguageService,
  sentryLogger: SentryLogger
): MetaReducer<CartState> {
  let first = true;
  return function (reducer: ActionReducer<CartState>): ActionReducer<CartState> {
    return (state: CartState, action) => {
      if (first && action.type === UPDATE) {
        first = false;
        const corruptedParts: string[] = safeMap(state?.isUpdating, (parts: UpdatingCartPart) =>
          Object.keys(parts).filter((partId: string) => parts[partId] === CartPartStatus.UPDATING)
        );

        if (isNotEmpty(corruptedParts)) {
          sentryLogger.error('Cart was updating during page reload', {
            cartId: state?.cartData?.id,
            corruptedParts,
          });
          navigateToError(router, languageService.langValue, 'TECHNICAL_ERROR');
        }
      }
      return reducer(state, action);
    };
  };
}
